import { render, staticRenderFns } from "./customerComponents.vue?vue&type=template&id=4caae360&scoped=true&"
import script from "./customerComponents.vue?vue&type=script&lang=js&"
export * from "./customerComponents.vue?vue&type=script&lang=js&"
import style0 from "./customerComponents.vue?vue&type=style&index=0&id=4caae360&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caae360",
  null
  
)

export default component.exports